import React from "react";
import {
  AuthenticationScreenMolecule,
  SearchVehicleDecoderMolecule,
} from "../../molecules";
import { useSessionContext } from "../../../hooks";

export const DecoderPage = (): JSX.Element => {
  const { tokenDecoder, clientId, clientSecret } = useSessionContext();

  if (tokenDecoder && clientId && clientSecret) {
    return <SearchVehicleDecoderMolecule />;
  }

  return <AuthenticationScreenMolecule />;
};
